var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"csr-input"},[_c('FormItem',_vm._b({},'FormItem',_setup.state.conf,false),[_c('MdAutocomplete',_vm._b({ref:"autocompleteRef",attrs:{"fetch-suggestions":_vm.fetchSuggestions},on:{"select":_setup.handleSelect,"input":_setup.handleInput,"blur":_setup.handleBlur},model:{value:(_setup.state.value),callback:function ($$v) {_vm.$set(_setup.state, "value", $$v)},expression:"state.value"}},'MdAutocomplete',{
          ..._vm.$attrs,
          ..._setup.state.conf
        },false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }